import { useState } from 'react';
import { backupApi } from '../../api/backup';
import { useToast } from '../../components/Toast';

export default function DataBackup() {
  const toast = useToast();
  const [exporting, setExporting] = useState(false);
  const [preview, setPreview] = useState<string | null>(null);

  const handleExport = async () => {
    setExporting(true);
    try {
      const json = await backupApi.export();
      setPreview(json);
      // Also trigger download
      const blob = new Blob([json], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `a5core_backup_${new Date().toISOString().substring(0, 10)}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast.addToast('Atsarginė kopija sėkmingai eksportuota', 'success');
    } catch (err) {
      toast.addToast(`Eksportas nepavyko: ${err instanceof Error ? err.message : 'Nežinoma klaida'}`, 'error');
    }
    setExporting(false);
  };

  return (
    <div className="space-y-6">
      <h1 className="text-xl font-bold text-gray-900">Atsarginės kopijos</h1>

      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <h2 className="font-semibold text-gray-900 mb-2">Eksportuoti atsarginę kopiją</h2>
        <p className="text-sm text-gray-600 mb-4">
          Eksportuoti visus įmonės duomenis kaip JSON failą. Tai apima sąskaitas, kontaktus,
          žurnalo įrašus, sąskaitas faktūras, mokesčių tarifus, dokumentų serijas ir visus
          susijusius įrašus.
        </p>
        <button
          className="px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 disabled:opacity-50"
          onClick={handleExport}
          disabled={exporting}
        >
          {exporting ? 'Eksportuojama…' : 'Eksportuoti visą atsarginę kopiją'}
        </button>
      </div>

      {preview && (
        <div className="bg-white rounded-lg border border-gray-200 p-4">
          <h2 className="font-semibold text-gray-900 mb-2">Peržiūra</h2>
          <pre className="text-xs bg-gray-50 p-3 rounded-md overflow-auto max-h-96">
            {preview.substring(0, 2000)}{preview.length > 2000 ? '\n... (sutrumpinta)' : ''}
          </pre>
        </div>
      )}

      <div className="bg-yellow-50 rounded-lg border border-yellow-200 p-4">
        <h3 className="font-semibold text-yellow-800 mb-1">Svarbu</h3>
        <ul className="text-sm text-yellow-700 space-y-1 list-disc list-inside">
          <li>Atsarginės kopijos faile yra visi dabartinės darbo srities finansiniai duomenys.</li>
          <li>Saugokite atsarginės kopijos failą saugiai — jame yra slaptos finansinės informacijos.</li>
          <li>Importavimas bus prieinamas būsimoje versijoje.</li>
        </ul>
      </div>
    </div>
  );
}
